// #region Imports

import * as $ from 'jquery';

// #endregion Imports

let _handleSafariBug = false;

// #region Exports

export function initialize(): void {
    wireHover();
    _handleSafariBug = checkIfSafariOniOS();
}

function checkIfSafariOniOS() {
    var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;

    return isSafari && iOS;
}

// #endregion Exports

// #region Private functions

function wireHover(): void {
    $('.js-expand-on-hover')
        .on('mouseenter', onMouseEnter)
        .on('mouseleave', onMouseLeave);
}

function onMouseEnter() {
    const target = $(this).find('.js-expand-on-hover-target');
    if (target.length === 0) {
        return;
    }

    expandElement(target[0]);
}

function onMouseLeave() {
    const target = $(this).find('.js-expand-on-hover-target');
    if (target.length === 0) {
        return;
    }

    collapseElement(target[0]);
}

function collapseElement(element) {
    if(_handleSafariBug) {
        element.classList.remove('greeter__list-info--safari-ios-sucks-hack');
        return;
    }

    // get the height of the element's inner content, regardless of its actual size
    var sectionHeight = element.scrollHeight;

    // temporarily disable all css transitions
    var elementTransition = element.style.transition;
    element.style.transition = '';

    // on the next frame (as soon as the previous style change has taken effect),
    // explicitly set the element's height to its current pixel height, so we 
    // aren't transitioning out of 'auto'
    requestAnimationFrame(() => {
        element.style.height = sectionHeight + 'px';
        element.style.transition = elementTransition;

        // on the next frame (as soon as the previous style change has taken effect),
        // have the element transition to height: 0
        requestAnimationFrame(() => {
            element.style.height = 0 + 'px';
        });
    });

    // mark the section as "currently collapsed"
    element.setAttribute('data-collapsed', 'true');
}

function expandElement(element) {
    if(_handleSafariBug) {
        element.classList.add('greeter__list-info--safari-ios-sucks-hack');
        return;
    }

    // get the height of the element's inner content, regardless of its actual size
    let sectionHeight = element.scrollHeight;
    
    // have the element transition to the height of its inner content
    element.style.height = sectionHeight + 'px';

    // when the next css transition finishes (which should be the one we just triggered)
    element.addEventListener('transitionend', e => {
        // remove this event listener so it only gets triggered once
        element.removeEventListener('transitionend', element);

        // remove "height" from the element's inline styles, so it can return to its initial value
        //element.style.height = null;
    });

    // mark the section as "currently not collapsed"
    element.setAttribute('data-collapsed', 'false');
}

// #endregion Private functions

